<template>
    <Teleport to="body">
        <div class="modal-bg-mask" @click.self="onCancel">
            <div class="confirm-modal">
                <div class="modal-header" v-if="msg.header">
                    {{msg.header}}
                </div>
                <div class="modal-msg" v-if="msg.msg">
                    {{msg.msg}}
                </div>
                <div class="modal-footer" v-if="msg.footer">
                    {{msg.footer}}
                </div>
                <div class="modal-btn-container">
                    <div class="firm-btn" @click="onConfirm">{{ localize('确定') }}</div>
                </div>
            </div>
        </div>
    </Teleport>
</template>

<script>
export default {
    name: 'NotificationModal',
    props: {
        header: String,
        msg: Object,
    },
    inject: ['langStore', 'localize'],
    methods: {
        onConfirm() {
            this.$emit('confirm')
        },
        onCancel() {
            this.$emit('cancel')
        }
    }
}
</script>

<style scoped>
.modal-bg-mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.35);
    backdrop-filter: blur(4px);
    -webkit-backdrop-filter: blur(4px);
    z-index: 999;
}

.confirm-modal {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 90%;
    max-height: 90%;
    box-sizing: border-box;
    overflow: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2em;
    z-index: 1000;
    background-color: #000000;
    padding: 1em 2em;
    border-radius: 0.4em;
    border: 1px solid #DDFD5C;
}

.modal-footer{
    white-space: pre-line;
    color: #ffffff;
    font-size: 1.6em;
    text-align: right;
    width: 100%;
}

.modal-header {
    font-size: 2em;
    color: #ffffff;
    margin: 0;
}

.modal-msg {
    color: #ffffff;
    line-height: 1.6;
    text-align: left;
    font-size: 2em;
    width: 100%;

}

.modal-btn-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 1em;
}

.firm-btn {
    font-size: 1.6em;
    padding: 0.2em 0.8em;
    border-radius: 0.1em;
    color: #ffffff;
    cursor: pointer;
    transition: all 0.3s;
    background-color: #7BE12F;
}

.firm-btn:hover {
    background-color: rgba(255, 255, 255, 0.1);
}

.firm-btn:active {
    transform: scale(0.95);
}
</style>